"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StadiumInput = StadiumInput;
var _react = _interopRequireDefault(require("react"));
var _client = require("@apollo/client");
var _AutoCompleteInput = require("./AutoCompleteInput");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // import React from 'react'
// import {gql, useLazyQuery} from '@apollo/client'
// import {Controller, useForm} from 'react-hook-form'
// import TextField from '@mui/material/TextField'
// import Autocomplete from '@mui/material/Autocomplete'
// import {AutoCompleteInput} from './AutoCompleteInput'
const Q_STADIUMS = (0, _client.gql)`
  query Stadiums {
    games(distinct_on: stadium) {
      stadium
    }
  }
`;

// export function StadiumInput({control}) {
//   console.log(`stadium component`, StadiumInput.displayName)
//   const [getStadiums, {data: games}] = useLazyQuery(Q_STADIUMS)
//   // console.log(`games`, games)
//   const stadiums =
//     games?.games
//       ?.map((game) => game.stadium)
//       .filter((stadium) => stadium != null) || []
//   // console.log('stadiums', stadiums)

//   const handleFocus = (e, cb) => {
//     // console.log('focus')
//     // console.log(e)
//     cb() // issue query
//   }

//   const handleChange = (e, newValue, onChange) => {
//     // console.log('onChange', !!e.target.value ? e.target.value : newValue)
//     onChange(!!e.target.value ? e.target.value : newValue)
//   }

//   return (
//     <Controller
//       name="stadium"
//       control={control}
//       render={({field: {onChange, value, ...rest}}) => {
//         return (
//           <Autocomplete
//             sx={{width: 300}}
//             freeSolo
//             size="small"
//             options={stadiums}
//             onFocus={(e) => handleFocus(e, getStadiums)}
//             onChange={(e, newValue) => handleChange(e, newValue, onChange)}
//             onInputChange={(e, newValue) => handleChange(e, newValue, onChange)}
//             renderInput={(params) => {
//               return <TextField value={value} {...params} label="Stadium" />
//             }}
//           />
//         )
//       }}
//     />
//   )
// }

function StadiumInput(props) {
  return /*#__PURE__*/_react.default.createElement(_AutoCompleteInput.AutoCompleteInput, _extends({
    query: Q_STADIUMS,
    field: "stadium"
  }, props, {
    sx: {
      width: 182
    }
  }));
}